import { useMemo, useState } from "react";
import {ReactComponent as UserFlowRowItem } from "./../assets/svgs/user-flow-item.svg"

const TabButton = ({ active, children, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={[
      "relative text-left text-[12px] leading-none transition-colors",
      active ? "text-black" : "text-[#9A9A9A] hover:text-black",
    ].join(" ")}
  >
    <span className="inline-block py-2">{children}</span>
    <span
      className={[
        "absolute left-0 right-0 -bottom-[10px] h-[2px] rounded-full transition-opacity",
        active ? "opacity-100 bg-black" : "opacity-0 bg-black",
      ].join(" ")}
    />
  </button>
);

const StepRow = ({ index, title, desc }) => (
  <div className="flex gap-4 py-5 border-t-[1px] border-t-[#CCC9C6]">
    {/* Icon block */}
    <div className="shrink-0">
      <div className="w-[80px] h-[80px] rounded-[10px] flex items-center justify-center">
        <UserFlowRowItem  />
      </div>
    </div>

    {/* Text */}
    <div className="min-w-0 flex-1">
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <div className="text-[9px] font-normal text-[#736F6C] mt-[12px]">{"0" + index}</div>
          <div className="text-[14px] font-medium text-[#1A1A1A]">{title}</div>
          <div className="text-[12.5px] font-normal leading-[18px] text-[#1A1A1A]">
            {desc}
          </div>
        </div>
      </div>
    </div>
  </div>
);

const Userflow = () => {
  const [tab, setTab] = useState("userFlow");

  const steps = useMemo(
    () => [
      {
        title: "Super Admin Setup",
        desc: "Eveness team creates the B2B partner account.",
      },
      {
        title: "API Key Issued",
        desc: "Brand admin logs into the B2B Portal to generate their secure API + secret key.",
      },
      {
        title: "Embed Survey or Input UI",
        desc: 'Brand integrates the "Take Survey" or style input module onto their site.',
      },
      {
        title: "Token Authenticated Requests",
        desc: "API calls are authenticated using secure OAuth tokens.",
      },
      {
        title: "ML Inference",
        desc: "Eveness engines return customised recommendations fit, color, outfit logic.",
      },
      {
        title: "User Output",
        desc: "Data is rendered natively on the partner's site (no redirect).",
      },
    ],
    [],
  );

  return (
    
    <section className="w-full grid grid-cols-1 gap-10 items-center">
      <div className="px-5 sm:px-8 py-10 sm:py-14 bg-[#F7F5F2] mx-[24px] rounded-[12px] ">
        <h2 className="text-[28px] sm:text-[34px] leading-tight font-medium text-black md:px-5">
          Integration made easy
        </h2>

        {/* Card */}
        <div className="mt-7 rounded-[14px]">
          <div className="grid grid-cols-1 lg:grid-cols-[220px_1fr]">
            {/* Left nav */}
            <div className="border-b-0 border-[#EFE7E1] lg:border-b-[1px] lg:border-[#EFE7E1]">
              <div className="px-6 pt-5 pb-6 lg:py-6">
                {/* Desktop vertical */}
                <div className="hidden lg:block space-y-3">
                  <button
                    type="button"
                    onClick={() => setTab("userFlow")}
                    className={[
                      "w-full text-left text-[12.5px] transition-colors border-b-[1px] border-[#CCC9C6] pb-[10px]",
                      tab === "userFlow"
                        ? "text-[#1A1A1A] font-bold"
                        : "text-[#736F6C] hover:text-black",
                    ].join(" ")}
                  >
                    User Flow
                  </button>
                  <button
                    type="button"
                    onClick={() => setTab("shopify")}
                    className={[
                      "w-full text-left text-[12.5px] transition-colors border-b-[1px] border-[#CCC9C6] pb-[10px] pt-[1px]",
                      tab === "shopify"
                        ? "text-[#1A1A1A] font-bold"
                        : "text-[#736F6C] hover:text-black",
                    ].join(" ")}
                  >
                    Shopify integration
                  </button>
                </div>

                {/* Mobile horizontal */}
                <div className="lg:hidden">
                  <div className="flex items-center gap-10 border-b border-[#EFE7E1] pb-3">
                    <TabButton
                      active={tab === "userFlow"}
                      onClick={() => setTab("userFlow")}
                    >
                      User Flow
                    </TabButton>
                    <TabButton
                      active={tab === "shopify"}
                      onClick={() => setTab("shopify")}
                    >
                      Shopify integration
                    </TabButton>
                  </div>
                </div>
              </div>
            </div>

            {/* Right content */}
            <div className="px-0 sm:px-7 py-6 sm:py-7">
              <div className="flex items-center justify-between gap-4">
                <div>
                  <div className="text-[22px] sm:text-[24px] font-medium text-black">
                    {tab === "userFlow" ? "User flow" : "Shopify integration"}
                  </div>
                </div>
              </div>

              <div className="mt-4 border-t border-[#EFE7E1]" />

              {/* Steps */}
              <div>
                {steps.map((s, i) => (
                  <StepRow
                    key={s.title}
                    index={i + 1}
                    title={s.title}
                    desc={s.desc}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="h-6" />
      </div>
    </section>
  );
};

export default Userflow;
